import { MessageBar, MessageBarType, Stack } from "@bps/fluent-ui";
import { NotificationType } from "@bps/stores";

import { useFeedbackStore } from "../core/stores";

export const Notifications = () => {
  const { notifications, close } = useFeedbackStore();

  return (
    <Stack
      styles={{
        root: { position: "absolute", right: 260, top: 8, zIndex: 100 }
      }}
    >
      {notifications.map(x => (
        <MessageBar
          key={x.key}
          messageBarType={toMessageBarType(x.type)}
          dismissButtonAriaLabel="Close"
          onDismiss={() => {
            close(x.key);
          }}
        >
          {x.message}
        </MessageBar>
      ))}
    </Stack>
  );
};

const toMessageBarType = (notificationType: NotificationType) => {
  switch (notificationType) {
    case "error":
      return MessageBarType.error;
    case "info":
      return MessageBarType.info;
    case "success":
      return MessageBarType.success;
    case "warning": {
      return MessageBarType.warning;
    }
  }
};
